import {Navigate} from "react-router-dom";

interface RedirectToProps {
  to: string;
}

export const RedirectTo: React.FC<RedirectToProps> = ({to}) => {
  return <Navigate to={to} replace />;
};
